import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getGoogleTranslateIntergration = async (
  token: string,
  baseUrl: string,
  params?: any,
  config?: any
) => {
  const queryPath = `${baseUrl}/google_translate_integration`;
  try {
    const res = await getData(token, queryPath, params, config);
    return deserialize(res.data);
  } catch (err) {
    throw new Error(err);
  }
};
